import Vue from 'vue';
import Router from 'vue-router';
import Manual from '@/views/Manual';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Manual',
      component: Manual,
      redirect: {
        name: 'productManualList',
      },
      children: [
        {
          path: '',
          name: 'productManualList',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "productManualList" */ '@/components/ProductManualList'),
        },
        {
          path: ':modelName',
          name: 'productManual',
          component: () => import(/* webpackChunkName: "productManual" */ '@/components/ProductManual'),
          props: true,
        },
      ],
    }
  ],
});
